function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M41.9929 1.16429C43.2341 0.444285 44.7659 0.444285 46.0071 1.16429L63.03 11.0391L80.0933 20.8439C81.3374 21.5589 82.1033 22.8854 82.1004 24.3203L82.06 44L82.1004 63.6797C82.1033 65.1146 81.3374 66.4411 80.0933 67.1561L63.03 76.9609L46.0071 86.8357C44.7659 87.5557 43.2341 87.5557 41.9929 86.8357L24.97 76.9609L7.90674 67.1561C6.66259 66.4411 5.8967 65.1146 5.89964 63.6797L5.94 44L5.89964 24.3203C5.8967 22.8854 6.66259 21.5589 7.90674 20.8439L24.97 11.0391L41.9929 1.16429Z",
  fill: "#ffd6dd"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M41.9929 1.16429C43.2341 0.444285 44.7659 0.444285 46.0071 1.16429L63.03 11.0391L80.0933 20.8439C81.3374 21.5589 82.1033 22.8854 82.1004 24.3203L82.06 44L82.1004 63.6797C82.1033 65.1146 81.3374 66.4411 80.0933 67.1561L63.03 76.9609L46.0071 86.8357C44.7659 87.5557 43.2341 87.5557 41.9929 86.8357L24.97 76.9609L7.90674 67.1561C6.66259 66.4411 5.8967 65.1146 5.89964 63.6797L5.94 44L5.89964 24.3203C5.8967 22.8854 6.66259 21.5589 7.90674 20.8439L24.97 11.0391L41.9929 1.16429Z",
  fill: "#FF8FA2"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_178_8871)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 44,
  cy: 88,
  r: 44,
  fill: "#EFEEFC"
}));

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 44,
  cy: 44,
  r: 23.5,
  fill: "#9087E5",
  stroke: "#41295a",
  strokeWidth: 3
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M34.6667 38.1667H38.1667C38.4761 38.1667 38.7728 38.0437 38.9916 37.825C39.2104 37.6062 39.3333 37.3094 39.3333 37V35.8333C39.3333 35.2145 39.5792 34.621 40.0168 34.1834C40.4543 33.7458 41.0478 33.5 41.6667 33.5C42.2855 33.5 42.879 33.7458 43.3166 34.1834C43.7542 34.621 44 35.2145 44 35.8333V37C44 37.3094 44.1229 37.6062 44.3417 37.825C44.5605 38.0437 44.8572 38.1667 45.1667 38.1667H48.6667C48.9761 38.1667 49.2728 38.2896 49.4916 38.5084C49.7104 38.7272 49.8333 39.0239 49.8333 39.3333V42.8333C49.8333 43.1428 49.9562 43.4395 50.175 43.6583C50.3938 43.8771 50.6906 44 51 44H52.1667C52.7855 44 53.379 44.2458 53.8166 44.6834C54.2542 45.121 54.5 45.7145 54.5 46.3333C54.5 46.9522 54.2542 47.5457 53.8166 47.9832C53.379 48.4208 52.7855 48.6667 52.1667 48.6667H51C50.6906 48.6667 50.3938 48.7896 50.175 49.0084C49.9562 49.2272 49.8333 49.5239 49.8333 49.8333V53.3333C49.8333 53.6428 49.7104 53.9395 49.4916 54.1583C49.2728 54.3771 48.9761 54.5 48.6667 54.5H45.1667C44.8572 54.5 44.5605 54.3771 44.3417 54.1583C44.1229 53.9395 44 53.6428 44 53.3333V52.1667C44 51.5478 43.7542 50.9543 43.3166 50.5168C42.879 50.0792 42.2855 49.8333 41.6667 49.8333C41.0478 49.8333 40.4543 50.0792 40.0168 50.5168C39.5792 50.9543 39.3333 51.5478 39.3333 52.1667V53.3333C39.3333 53.6428 39.2104 53.9395 38.9916 54.1583C38.7728 54.3771 38.4761 54.5 38.1667 54.5H34.6667C34.3572 54.5 34.0605 54.3771 33.8417 54.1583C33.6229 53.9395 33.5 53.6428 33.5 53.3333V49.8333C33.5 49.5239 33.6229 49.2272 33.8417 49.0084C34.0605 48.7896 34.3572 48.6667 34.6667 48.6667H35.8333C36.4522 48.6667 37.0457 48.4208 37.4832 47.9832C37.9208 47.5457 38.1667 46.9522 38.1667 46.3333C38.1667 45.7145 37.9208 45.121 37.4832 44.6834C37.0457 44.2458 36.4522 44 35.8333 44H34.6667C34.3572 44 34.0605 43.8771 33.8417 43.6583C33.6229 43.4395 33.5 43.1428 33.5 42.8333V39.3333C33.5 39.0239 33.6229 38.7272 33.8417 38.5084C34.0605 38.2896 34.3572 38.1667 34.6667 38.1667Z",
  fill: "white"
});

function SvgBadge4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_178_8871",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 0,
    width: 78,
    height: 88
  }, _ref3), _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadge4);
export default __webpack_public_path__ + "static/media/Badge4.4a2c613d.svg";
export { ForwardRef as ReactComponent };